<template>
  <div>
    <el-container>
      <el-header>合并订单</el-header>
      <el-main>
        <el-form :model="info" ref="info" label-width="80px">
          <el-form-item label="订单号" prop="order_no" :rules="[{ required: true, message: '订单号不能为空' }]">
            <el-input v-model="info.order_no" placeholder="请输入主订单号" style="width: 60%;"></el-input>
          </el-form-item>
          <el-form-item label="订单金额" prop="total_amount">
            <el-input type="number" v-model="info.total_amount" placeholder="请输入主订单金额" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="remark" :rules="[{ required: true, message: '说明不能为空' }]">
            <el-input v-model="info.remark" type="textarea" placeholder="请输入说明" :autosize="true" style="width: 80%;"
              rows="5"></el-input>
          </el-form-item>

          <el-divider></el-divider>

          <el-form-item label="子订单">
            <el-row>
              <el-table :data="info.sub_order" border :stripe="true" style="width: 80%;">
                <el-table-column label="订单号" align="left" min-width="12%">
                  <template slot-scope="{ row }">
                    <el-input v-model="row.order_no" clearable placeholder="请输入订单号" style="width: 90%;"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="金额" align="center" min-width="5%">
                  <template slot-scope="{ row }">
                    <el-input type="number" v-model="row.amount" clearable placeholder="请输入订单金额"
                      style="width: 90%;"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="操作" align="center" min-width="5%">
                  <template slot-scope="row">
                    <i v-if="row.$index > 0" class="el-icon-remove" @click="delInfoField(row.$index)"></i>
                    <el-button v-if="row.$index == 0" @click="addNewInfoField()" type="danger" icon="el-icon-circle-plus"
                      style="float: center;" size="mimi">添加行</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-form-item>

          <br />
          <el-form-item>
            <el-button size="mini" type="primary" @click="submitForm('info')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-container>
      <el-header>订单课程替换</el-header>
      <el-main>
        <el-form :model="info1" ref="info1" label-width="80px">
          <el-form-item label="订单号" prop="order_no" :rules="[{ required: true, message: '订单号不能为空' }]">
            <el-input v-model="info1.order_no" placeholder="请输入订单号" style="width: 60%;"></el-input>
          </el-form-item>
          <el-form-item label="新课程ID" prop="new_course_id" :rules="[{ required: true, message: '新课程ID不能为空' }]">
            <el-input type="number" v-model="info1.new_course_id" placeholder="请输入新课程ID" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="remark" :rules="[{ required: true, message: '说明不能为空' }]">
            <el-input v-model="info1.remark" type="textarea" placeholder="请输入说明" :autosize="true" style="width: 80%;"
              rows="5"></el-input>
          </el-form-item>
          <el-form-item label="分润">
            <el-checkbox v-model="info1.not_verify_revenue" value="true">不验证</el-checkbox>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="submitForm1('info1')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-container>
      <el-header>订单完成</el-header>
      <el-main>
        <el-form :model="info2" ref="info2" label-width="80px">
          <el-form-item label="订单号" prop="order_no" :rules="[{ required: true, message: '订单号不能为空' }]">
            <el-input v-model="info2.order_no" placeholder="请输入订单号" style="width: 60%;"></el-input>
          </el-form-item>
          <el-form-item label="金额" prop="total_amount" :rules="[{ required: true, message: '金额不能为空' }]">
            <el-input v-model="info2.total_amount" placeholder="请金额" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="积分" prop="score_amount" :rules="[{ min: 1, message: '积分不能小于0' }]">
            <el-input type="number" v-model="info2.score_amount" placeholder="请抵扣积分" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="remark" :rules="[{ required: true, message: '说明不能为空' }]">
            <el-input v-model="info2.remark" type="textarea" placeholder="请输入说明" :autosize="true" style="width: 80%;"
              rows="5"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="submitForm2('info2')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-container>
      <el-header>订单分润收回</el-header>
      <el-main>
        <el-form :model="info3" ref="info3" label-width="80px">
          <el-form-item label="订单号" prop="order_no" :rules="[{ required: true, message: '订单号不能为空' }]">
            <el-input v-model="info3.order_no" placeholder="请输入订单号" style="width: 60%;"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="remark" :rules="[{ required: true, message: '说明不能为空' }]">
            <el-input v-model="info3.remark" type="textarea" placeholder="请输入说明" :autosize="true" style="width: 80%;"
              rows="5"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="submitForm3('info3')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-container>
      <el-header>补录教务学员线下课分润列表</el-header>
      <el-main>
        <el-form :model="info4" ref="info4" label-width="80px">
          <el-form-item label="订单号" prop="order_no" :rules="[{ required: true, message: '订单号不能为空' }]">
            <el-input v-model="info4.order_no" placeholder="请输入订单号" style="width: 60%;"></el-input>
          </el-form-item>
          <el-form-item label="教务系统课程ID" prop="course_id" :rules="[{ required: true, message: '教务系统课程ID不能为空' }]">
            <el-input type="number" v-model="info4.course_id" placeholder="请输入教务系统课程ID" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="已交付课期ID" prop="period_id" :rules="[{ required: true, min: 1, message: '已交付课期ID不能小于0' }]">
            <el-input type="number" v-model="info4.period_id" placeholder="请输入已交付课期ID" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="remark" :rules="[{ required: true, message: '说明不能为空' }]">
            <el-input v-model="info4.remark" type="textarea" placeholder="请输入说明" :autosize="true" style="width: 80%;"
              rows="5"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="submitForm4('info4')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-container>
      <el-header>账号合并</el-header>
      <el-main>
        <el-form :model="info5" ref="info5">
          <el-form-item label="手机号1" prop="mobile_phone" :rules="[{ required: true, message: '手机号1不能为空' }]">            
            <el-input v-model="info5.mobile_phone" placeholder="请输入手机号1" style="width: 60%;"></el-input>
          </el-form-item>
          <el-form-item label="手机号2，即需要合并的手机号（废弃的手机号）" prop="old_mobile_phone">
            <el-input v-model="info5.old_mobile_phone" placeholder="请输入手机号2" style="width: 30%;"></el-input>
          </el-form-item>
          <el-form-item label="需要合并的用户订单" prop="order_no">
            <el-input v-model="info5.order_no" placeholder="请输入订单号" style="width: 60%;"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="submitForm5('info5')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mergeOrderADYUPNGXCJBS, orderCourseReplaceYJXWQZMQ, orderFinishHYELEVEU, orderShareBenefitRetakeHYELEVEU, orderJWStudentToCRMBenefit, userMergeKETRCHBLUK } from "@/api/order";

export default {
  data: function () {
    return {
      validateSubOrder: true,
      info: {
        order_no: "",
        total_amount: "",
        remark: "",
        sub_order: [
          {
            order_no: "",
            amount: "",
          },
        ],
      },
      info1: {
        order_no: "",
        new_course_id: "",
        remark: "",
        not_verify_revenue: false,
      },
      info2: {
        order_no: "",
        total_amount: "",
        score_amount: "",
        remark: "",
      },
      info3: {
        order_no: "",
        remark: "",
      },
      info4: {
        order_no: "",
        course_id: "",
        period_id: "",
        remark: "",
      },
      info5: {
        mobile_phone: "",
        old_mobile_phone: "",
        order_no: "",
      },
    };
  },
  methods: {
    submitForm5 (formName) {
      this.validateSubOrder = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("此操作将执行 账号合并, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            userMergeKETRCHBLUK(this.info5).then((response) => {
              if (response.status == 2000) {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "success",
                });
              }
            });
          });
        } else {
          return false;
        }
      });
    },

    submitForm4 (formName) {
      this.validateSubOrder = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("此操作将执行补录教务学员线下课分润列表操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            orderJWStudentToCRMBenefit(this.info4).then((response) => {
              if (response.status == 2000) {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "success",
                });
              }
            });
          });
        } else {
          return false;
        }
      });
    },

    submitForm3 (formName) {
      this.validateSubOrder = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("此操作将执行订单分润收回操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            orderShareBenefitRetakeHYELEVEU(this.info3).then((response) => {
              if (response.status == 2000) {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "success",
                });
              }
            });
          });
        } else {
          return false;
        }
      });
    },

    submitForm2 (formName) {
      this.validateSubOrder = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("此操作将执行订单完成操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            orderFinishHYELEVEU(this.info2).then((response) => {
              if (response.status == 2000) {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "success",
                });
              }
            });
          });
        } else {
          return false;
        }
      });
    },

    addNewInfoField () {
      this.info.sub_order.push({
        order_no: "",
        amount: "",
      });
    },
    delInfoField (infoFieldIndex) {
      this.info.sub_order.splice(infoFieldIndex, 1);
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },

    submitForm (formName) {
      this.validateSubOrder = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.info.sub_order.forEach((item) => {
            if (item.order_no == "" || Number(item.amount) <= 0) {
              this.validateSubOrder = false;
            }
          });
          if (!this.validateSubOrder) {
            this.$message({
              showClose: true,
              message: "子订单号 和 金额 错误",
              type: "error",
            });
          } else {
            this.doMerge();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitForm1 (formName) {
      this.validateSubOrder = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("此操作将执行订单课程替换操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            orderCourseReplaceYJXWQZMQ(this.info1).then((response) => {
              if (response.status == 2000) {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "success",
                });
              }
            });
          });
        } else {
          return false;
        }
      });
    },

    doMerge () {
      this.$confirm("此操作将执行合并订单操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mergeOrderADYUPNGXCJBS(this.info).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: response.message,
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style>
.el-header,
.el-footer {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 60px;
  margin-top: 10px;
  font-size: 25px;
}
</style>
